export function obterListaMotivoDesoneracaoSt() {
  return (
    [
      { label: '03 - Produto Agropecuário', value: 'PRODUTOAGROPECUARIO' },
      { label: '09 - Outros', value: 'OUTROS' },
      { label: '12 - Fomento Agropecuário', value: 'FOMENTOAGROPECUARIO' },
    ]
  );
}
